import { render, staticRenderFns } from "./AppItemBox.vue?vue&type=template&id=0a5516b8&"
import script from "./AppItemBox.vue?vue&type=script&lang=js&"
export * from "./AppItemBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports